import { Flame } from "lucide-react";

/** 7-day quiz strip + learning streak, shown at the top of the Learn panel. */
export function LearnStatsStrip({ stats, t }) {
  if (!stats) return null;
  const days = stats.days || [];
  const weekday = (iso) => new Date(iso + "T12:00:00Z").toLocaleDateString(undefined, { weekday: "narrow" });
  return (
    <div className="mb-3 rounded-xl bg-white/60 dark:bg-white/5 border border-[#5A8B8F]/20 p-3" data-testid="learn-stats">
      <div className="flex items-center justify-between gap-2 mb-2">
        <p className="text-[10px] font-bold uppercase tracking-widest text-[#1E5C2E]/70 dark:text-green-200/70">
          {t("learn.statsTitle")}
        </p>
        <p className="text-[11px] font-semibold text-[#1A1D1E] dark:text-slate-100" data-testid="learn-week-correct">
          {t("learn.weekCorrect", { correct: stats.week_correct, answered: stats.week_answered })}
        </p>
      </div>
      <div className="flex items-end justify-between gap-1" data-testid="learn-week-days">
        {days.map((d) => {
          const ok = d.correct > 0;
          const tried = d.answered > 0;
          return (
            <div key={d.date} className="flex flex-col items-center gap-1 flex-1">
              <div
                className={`h-7 w-7 rounded-full flex items-center justify-center text-[11px] font-bold transition ${
                  ok ? "bg-[#3AA35B] text-white" : tried ? "bg-amber-200 text-amber-800" : "bg-slate-200/70 dark:bg-white/10 text-slate-400"
                }`}
                data-testid={`learn-day-${d.date}`}
                title={`${d.correct}/${d.answered}`}
              >
                {tried ? d.correct : "·"}
              </div>
              <span className="text-[9px] uppercase text-[#1E5C2E]/60 dark:text-green-200/60">{weekday(d.date)}</span>
            </div>
          );
        })}
      </div>
      <div className="mt-2 flex items-center gap-1.5 text-[11px]" data-testid="learn-streak">
        <Flame className={`h-3.5 w-3.5 ${stats.streak > 0 ? "text-orange-500" : "text-slate-400"}`} />
        <span className="font-semibold text-[#1A1D1E] dark:text-slate-100">
          {stats.streak > 0 ? t("learn.streak", { n: stats.streak }) : t("learn.streakNone")}
        </span>
        <span className="text-[#1E5C2E]/70 dark:text-green-200/70 truncate">
          {stats.streak_bonus_today
            ? `· ${t("learn.streakBonusToday", { points: stats.streak_bonus_today })}`
            : stats.next_bonus_at
              ? `· ${t("learn.streakNext", { n: stats.next_bonus_at })}`
              : ""}
        </span>
      </div>
    </div>
  );
}
